import React from 'react'
import { useSelector } from 'react-redux'

import TasksBoardView from 'pages/parts/tasks/TasksBoardView'

function Index() {
	const reduxAccount = useSelector(state => state.account)

	function sameLogin(login) {
		return String(login || '').toLowerCase() === String(reduxAccount?.login || '').toLowerCase()
	}

	// Удалять задачу и менять состав исполнителей может только автор
	function canManageTask(task) {
		if (!task || !task.created_by) return false
		return sameLogin(task.created_by)
	}

	// Редактировать может ещё и тот, кого поставили исполнителем: лид ведут вместе,
	// поэтому соисполнителю нужны и срок, и телефоны, и точка
	function canEditTask(task) {
		if (canManageTask(task)) return true
		return (task?.users || []).some(item => sameLogin(item.login))
	}

	return (
		<TasksBoardView
			apiPrefix="/partner"
			currentUserLogin={reduxAccount?.login}
			canManageTask={canManageTask}
			canEditTask={canEditTask}
		/>
	)
}

export default Index
